import 'react-native-gesture-handler';
import React, {useEffect, useState} from 'react';
import Main from './src/components/main';
import {Provider} from 'react-redux';
import configureStore from './src/store/configureStore';
import CostCalculatorScreen from './src/components/costCalculator/CostCalculatorScreen';
import {
  isPublicCostCalculatorRoute,
  PUBLIC_COST_CALCULATOR_API_URL
} from './src/utils/publicRoutes';
import {Text, View, TouchableOpacity} from 'react-native';
import SocketSession from './src/components/socketSession';
// import axios from 'axios';
import axios from './src/config/axios';
import {Client} from 'rollbar-react-native';
import ErrorBoundary from './src/components/errorBoundary';

import {
  useFonts,
  Poppins_100Thin,
  Poppins_200ExtraLight,
  Poppins_300Light,
  Poppins_400Regular,
  Poppins_500Medium,
  Poppins_600SemiBold,
  Poppins_700Bold,
  Poppins_800ExtraBold,
  Poppins_900Black
} from '@expo-google-fonts/poppins';
import AsyncStorage from '@react-native-async-storage/async-storage';
import './fontello/css/gp_icons.css';
import * as Localization from 'expo-localization';
import i18n from 'i18n-js';
import en from './src/helpers/textFile';
import es from './src/helpers/es';
import PrinterShow from './src/components/directPrinting/printerShow';
import ReprintModal from './src/components/reprint/ReprintModal';
import {executeReprint, isReprintEnabled, getReprintDuration, getPrintTypeDisplayName} from './src/components/reprint/reprintUtils';
import PopUpModel from './src/components/scanpack/pop_up_model';
import {fetchData, handlePrinterSelection, handleQzError, setupPrinterStatusCallbacks, stopPrinterStatusCallbacks} from './qzservice';
import { initConnection } from './qzConnectionManager';
import rollbarConfig from './rollbarConfig';
import {getLiveStatsData} from './src/helpers/scanPackFunctions';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {useLanguageLoader} from './src/helpers/useLanguageLoader';
import FlashMessage from "react-native-flash-message";
import {initializeLogger} from './src/utils/frontendLogger';
import {fontConfig, getFontLoadingTimeout, logFontStatus} from './src/config/fontConfig';
import useAppSocket from './src/hooks/useAppSocket';
import PrintSlipNoticeHost from './src/components/ScanpackScanning/PrintSlipNoticeHost';
import {isAdminTenant, readPersistedUserInfo} from './src/helpers/adminTenant';
import {GetBothSettings} from './src/actions/userAction';
import {createSocketHandlers, resetBulkProgress} from './src/services/socket/socketHandlers';
i18n.fallbacks = true;
i18n.translations = {en,es};
i18n.locale = Localization.locale;
const store = configureStore();


const rollbarNative = new Client({
  accessToken: rollbarConfig.rollbarAccessToken,
  environment: __DEV__ ? 'development' : 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureDeviceInfo: true
});
const rollbar = rollbarNative.rollbar;
let barcode = true;
let msgData = '';

export {
  TERMINAL_BULK_ACTION_STATUSES,
  buildBulkActionUpdate,
  buildBulkTagActionUpdate,
  buildDisconnectRecovery
} from './src/services/socket/socketHandlers';

export default function App() {
  let [fontsLoaded, fontError] = useFonts({
    Poppins_100Thin,
    Poppins_200ExtraLight,
    Poppins_300Light,
    Poppins_400Regular,
    Poppins_500Medium,
    Poppins_600SemiBold,
    Poppins_700Bold,
    Poppins_800ExtraBold,
    Poppins_900Black
  });

  // Font loading timeout state
  const [fontLoadTimeout, setFontLoadTimeout] = useState(false);

  // 🔍 DIAGNOSTIC: Log font loading status
  useEffect(() => {
    logFontStatus(`Font Loading Status: fontsLoaded=${fontsLoaded}, hasError=${!!fontError}`);

    if (fontError) {
      console.error('❌ Font Loading Error Details:', {
        message: fontError.message,
        stack: fontError.stack,
        name: fontError.name,
        error: fontError
      });
    }
  }, [fontsLoaded, fontError]);

  // 🔍 DIAGNOSTIC: Check if fonts are hanging
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!fontsLoaded && !fontError) {
        logFontStatus('⚠️ Fonts still loading after 10 seconds! loadAsync() may be hanging.', 'warn');
        console.warn('This usually means:');
        console.warn('1. Network is very slow');
        console.warn('2. Font files are not being served');
        console.warn('3. CORS issue blocking font download');
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, [fontsLoaded, fontError]);

  const [url, setUrl] = useState('');
  const [message, setMessage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [selectedPrinter, setSelectedPrinter] = useState('');
  const [dimension, setDimension] = useState({});
  const [progressCount, setProgressCount] = useState(0);
  const [actionMsg, setActionMsg] = useState(0);
  const [progressLabel, setProgressLabel] = useState(null);
  const [, setRedirectData] = useState(false);
  const [updateOrders, setUpdateOrders] = useState(false);
  const [updateProducts, setUpdateProducts] = useState(false);
  const [bulkActionResult, setBulkActionResult] = useState(null);
  const [showReprintModal, setShowReprintModal] = useState(false);
  const [reprintDuration, setReprintDuration] = useState(20000);
  const [reprintPrintType, setReprintPrintType] = useState('label');
  const [popUpModelShow, setPopUpModelShow] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState('');
  const [popUpTestId, setPopUpTestId] = useState(null);

  //hook that will handle the language translation
  useLanguageLoader();

  // Enhanced alertBox function - supports callback for OK button
  const [alertCallback, setAlertCallback] = useState(null);
  const [showOnlyClose, setShowOnlyClose] = useState(false);

  const alertBox = (message, callback = null, onlyCloseButton = false, testId = null) => {
    setPopUpMessage(message);
    setPopUpModelShow(true);
    setAlertCallback(() => callback);
    setShowOnlyClose(onlyCloseButton);
    setPopUpTestId(testId);

    // Only auto-close if no callback and not set to show only close button
    if (!callback && !onlyCloseButton) {
      setTimeout(() => {
        setPopUpModelShow(false);
        setPopUpMessage('');
        setPopUpTestId(null);
      }, 6000);
    }
  };

  const closeAlert = () => {
    setPopUpModelShow(false);
    setPopUpMessage('');
    setAlertCallback(null);
    setShowOnlyClose(false);
    setPopUpTestId(null);
  };

  const handleOK = () => {
    if (alertCallback && typeof alertCallback === 'function') {
      alertCallback();
    }
    closeAlert();
  };

  // Font loading timeout effect
  useEffect(() => {
    const timeout = getFontLoadingTimeout();

    if (timeout > 0 && !fontsLoaded) {
      logFontStatus(`Setting font loading timeout to ${timeout}ms`);

      const timer = setTimeout(() => {
        if (!fontsLoaded) {
          logFontStatus(`Font loading timeout reached (${timeout}ms). Proceeding with fallback fonts.`, 'warn');
          setFontLoadTimeout(true);
        }
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, [fontsLoaded]);

  // Log font loading status
  useEffect(() => {
    if (fontsLoaded) {
      logFontStatus('Fonts loaded successfully!', 'success');
    }
  }, [fontsLoaded]);

  const printlabel = async (setting, msg) => {
    let dimensionShipping = (
      msg?.data?.dimensions ||
      (msg?.data?.print_type === 's2c_shipping_label' ? '4x6' : '')
    ).split('x');
    setUrl(msg?.data?.url);
    try{
      let data = await fetchData(msg?.data, alertBox);
      setPrinters(JSON.parse(JSON.stringify(data?.printersList)));
      msgData = msg?.data;
    let packingSlipSize = await AsyncStorage.getItem('Packing_slip_size');
    let shippingLabel =
      (msg?.data?.print_type === 'packing_slip'
        ? await AsyncStorage.getItem(
            `user_selected_printer_packing_slip_${packingSlipSize}`
          )
        : msg?.data?.print_type === 's2c_shipping_label'
        ? await AsyncStorage.getItem('print_ss_shipping_labels')
        : msg?.data?.print_type === 'product_barcode'
        ? await AsyncStorage.getItem(
            `print_product_barcode_labels_${
              (await AsyncStorage.getItem('Product_Barcode_label_size')) || '{}'
            }`
          )
        : await AsyncStorage.getItem(
            'user_selected_printer_order_barcode_label'
          )) || '';
    if (shippingLabel.length === 0) {
      if (data?.printersList?.length > 0) {
        setIsModalVisible(true);
      } else {
        setIsModalVisible(false);
        alertBox(i18n.t('directprinting.alertForNoPrinter'), null, true);
        window.open(msg?.data?.url, '_blank', 'noopener,noreferrer');
      }
    } else {
      setIsModalVisible(false);
      const selectedPrinter = JSON.parse(shippingLabel);

        await handlePrinterSelection(
          selectedPrinter,
          msg?.data?.url,
          setting,
          msgData,
          {width: dimensionShipping[0], height: dimensionShipping[1]},
          null,
          alertBox
        );
        // WebSocket-based reprint completely removed - now using direct API-based triggering from scanpack_item.js
        // storeLastPrintJob(msg, setting, selectedPrinter);
        // checkAndShowReprintModal(msg, setting);
      }

    }catch(e){
      console.error('QZ connection failed in printlabel:', e);
      // Handle QZ connection failure using existing PopUpModel pattern
      handleQzError(e, msg?.data?.url, alertBox);
    }
  };

  const checkAndShowReprintModal = async (msg, setting) => {
    try {
      let scanPackSettings = null;

      try {
        const access_token = await AsyncStorage.getItem('access_token');
        const url = await AsyncStorage.getItem('url');
        const response = await axios({
          method: 'get',
          url: `${url}/settings/get_setting.json`,
          headers: {Authorization: `Bearer ${access_token}`}
        });
        scanPackSettings = response?.data?.data?.scanpack_setting;
      } catch (fetchError) {
        console.error('Error fetching scan pack settings:', fetchError);
      }

      if (isReprintEnabled(scanPackSettings)) {
        const duration = getReprintDuration(scanPackSettings);
        const printTypeDisplay = getPrintTypeDisplayName(msg?.data?.print_type);

        setTimeout(() => {
          setReprintDuration(duration);
          setReprintPrintType(printTypeDisplay);
          setShowReprintModal(true);
        }, 5000);
      }
    } catch (error) {
      console.error('Error checking reprint settings:', error);
    }
  };

  const handleReprint = async () => {
    try {
      setShowReprintModal(false);
      const success = await executeReprint(alertBox);
      if (!success) {
        console.error('Failed to execute reprint');
      }
    } catch (error) {
      console.error('Error during reprint:', error);
    }
  };

  const handleReprintCancel = () => {
    setShowReprintModal(false);
  };

  const restProgress = () => {
    resetBulkProgress();
    setProgressCount(0);
    setUpdateOrders(false);
    setUpdateProducts(false);
    setBulkActionResult(null);
    setProgressLabel(null);
  };

  const {socket: currentSocket, connect: socketFun} = useAppSocket(
    createSocketHandlers({
      dispatch: store.dispatch,
      getSettings: () => store.getState().user?.bothSettings?.data?.data?.general_setting,
      printlabel,
      logout: () => logout_me(),
      setMessage,
      setDimension,
      setProgressCount,
      setActionMsg,
      setProgressLabel,
      setUpdateOrders,
      setUpdateProducts,
      setBulkActionResult,
      setDashboardData
    })
  );

  // The socket print gate reads bothSettings, so App loads it itself instead of relying on whichever screen is open.
  const loadSettings = async () => {
    const access_token = await AsyncStorage.getItem('access_token');

    if (!access_token) { return; }
    if (isAdminTenant(await readPersistedUserInfo())) { return; }

    store.dispatch(GetBothSettings());
  };

  useEffect(() => {
    loadSettings();
  }, []);

  useEffect(() => {
    const initLogging = async () => {
      try {
        // Initialize logger
        await initializeLogger();
      } catch (error) {
        console.error('Failed to initialize frontend logging:', error);
      }
    };

    initLogging();
  }, []);



  const getData = data => {
    setRedirectData(data);
  };
  const fetchDashboardData = async () => {
    await getLiveStatsData()
  };

  useEffect(() => {
    initConnection();
    socketFun();
    barcode = true;
  }, []);

  useEffect(()=>{
      setTimeout(() => {
        currentSocket && fetchDashboardData();
      },2000)
  },[])

  useEffect(() => {
    let lastProcessedTimestamp = 0;

    const checkReprintTrigger = async () => {
      try {
        const reprintTrigger = await AsyncStorage.getItem('reprint_trigger');
        if (reprintTrigger) {
          const data = JSON.parse(reprintTrigger);

          if (data.timestamp && data.timestamp !== lastProcessedTimestamp) {
            lastProcessedTimestamp = data.timestamp;

            let scanPackSettings = null;
            try {
              const access_token = await AsyncStorage.getItem('access_token');
              const url = await AsyncStorage.getItem('url');
              const response = await axios({
                method: 'get',
                url: `${url}/settings/get_setting.json`,
                headers: {Authorization: `Bearer ${access_token}`}
              });
              scanPackSettings = response?.data?.data?.scanpack_setting;
            } catch (fetchError) {
              console.error('Error fetching scan pack settings:', fetchError);
            }

            if (isReprintEnabled(scanPackSettings)) {
              const duration = getReprintDuration(scanPackSettings);
              const printTypeDisplay = getPrintTypeDisplayName(data.printType);

              setTimeout(() => {
                setReprintDuration(duration);
                setReprintPrintType(printTypeDisplay);
                setShowReprintModal(true);
              }, 5000);
            }

            await AsyncStorage.removeItem('reprint_trigger');
          }
        }
      } catch (error) {
        console.error('Error checking reprint trigger:', error);
      }
    };
    const interval = setInterval(checkReprintTrigger, 500);
    return () => clearInterval(interval);
  }, []);

  const logout_everyone = () => {
    currentSocket.emit('logout_everyone_else');
    setMessage('');
  };

  const logout_me = async () => {
    if (currentSocket) { currentSocket.disconnect(true); }

    const access_token = await AsyncStorage.getItem('access_token');
    const tenent = await AsyncStorage.getItem('tenent');
    const url = await AsyncStorage.getItem('url');

    try {
      if (access_token?.length && url?.length) {
        const logout_time = new Date().toISOString();
        await axios.post(`${url}/users/update_logout_time.json`,
          { logout_time },
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
              'Content-Type': 'application/json',
              tenent: tenent
            }
          }
        );
      }
    } catch (e) {
      console.log('Logout time update error:', e);
    }

    await AsyncStorage.removeItem('tenant');
    await AsyncStorage.removeItem('access_token');
    await AsyncStorage.removeItem('Logging');
    await AsyncStorage.removeItem('userInfo');
    await AsyncStorage.removeItem('store_id_inventory');

    window.location.reload();
  };
  //   const socket = io("https://socket.groovepacker.com/socket.io/", {
  //     query:
  //       "fingerprint=" +
  //       new Fingerprint({
  //         canvas: true,
  //         screen_resolution: true,
  //         transports: ["websocket", "polling"],
  //       }).get() +
  //       "&token=" +
  //       access_token,
  //   });
  // Show loading screen only if fonts haven't loaded AND timeout hasn't been reached
  const shouldShowLoading = !fontsLoaded && !fontLoadTimeout && fontConfig.showLoadingScreen;

  if (shouldShowLoading) {
    return <Text>Loading!</Text>;
  } else {
    // Proceed with app rendering (either fonts loaded OR timeout reached)
    if (fontLoadTimeout && !fontsLoaded) {
      logFontStatus('App rendering with fallback fonts due to timeout', 'warn');
    }

    // Public, unauthenticated entry point — reached at /cost-calculator with no login,
    // for prospects on the marketing funnel (gp-ebook WL-5). GPX has no router or prior
    // public-route precedent: every other screen lives behind Main's login-gated
    // Stack.Navigator (src/components/main.js sets initialRouteName to 'SignIn' whenever
    // there's no access_token). This intentionally skips Main/SignIn/the Stack.Navigator
    // entirely rather than trying to carve an exception into that flow. Known simplification:
    // the socket/QZ-printing effects above still run for this route (they no-op harmlessly
    // without a token) — a public-route-aware App.js is a larger refactor left for later.
    if (isPublicCostCalculatorRoute()) {
      return (
        <Provider store={store}>
          <CostCalculatorScreen apiUrlOverride={PUBLIC_COST_CALCULATOR_API_URL} />
        </Provider>
      );
    }

    return (
      <Provider store={store}>
        {message?.length > 0 && (
          <SocketSession
            logout_everyone={() => logout_everyone()}
            logout_me={() => logout_me()}
          />
        )}
        {isModalVisible && (
          <PrinterShow
            dataPrinter={printers}
            url={url}
            label="shipping_label"
            handlePrinterSelection={async printer => {
              let printerData = await handlePrinterSelection(
                printer,
                url,
                null,
                msgData,
                dimension
              );
              setIsModalVisible(false);
              setSelectedPrinter(printerData.type);
              console.log('DEBUG: Printer selected, storing print job and checking reprint');
              const socketMsg = {
                data: {
                  url: url,
                  print_type: msgData?.print_type || msgData,
                  dimensions: `${dimension.width}x${dimension.height}`,
                  increment_id: msgData?.increment_id
                }
              };
              // WebSocket-based reprint completely removed - now using direct API-based triggering from scanpack_item.js
              // storeLastPrintJob(socketMsg, newSet?.data?.data?.settings, printer);
              // checkAndShowReprintModal(socketMsg, newSet?.data?.data?.settings);
           }}
           closePrompt={() => {
             setIsModalVisible(false);
             const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
             if (newWindow) newWindow.focus();
           }}
         ></PrinterShow>
       )}

        {/* Reprint Modal */}
        <ReprintModal
          visible={showReprintModal}
          onReprint={handleReprint}
          onCancel={handleReprintCancel}
          duration={reprintDuration}
          printType={reprintPrintType}
        />

       {/* {modalQZ && (
      <AlertBoxSaving name ={i18n.t('directprinting.printComplete')}></AlertBoxSaving>
      )} */}
       {/* Notification PopUp for printer errors */}
       {popUpModelShow && (
         <PopUpModel
           closeAlert={closeAlert}
           message={popUpMessage}
           messageTypeSuccess={false}
           showOKButton={alertCallback !== null && !showOnlyClose}
           onOKPress={handleOK}
           errorTestId={popUpTestId}
         />
       )}

       <ErrorBoundary instance={rollbar}>
          <GestureHandlerRootView style={{ flex: 1 }}>
            <Main
              socketFun={() => socketFun()}
              restProgress={() => restProgress()}
              currentSocket={currentSocket}
              isModalVisible={isModalVisible}
              getData={getData}
              progressCount={progressCount}
              actionMsg={actionMsg}
              progressLabel={progressLabel}
              updateOrders={updateOrders}
              updateProducts={updateProducts}
              bulkActionResult={bulkActionResult}
              dashboardData={dashboardData}
            />
            <FlashMessage
              position="top"
              style={{
                position: 'absolute',
                top: 40,
                right: 20,
                left: 'auto',
                width: 250,
                borderRadius: 10,
                elevation: 5,
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.3,
                shadowRadius: 4,
              }}
              floating={true}
            />
            <PrintSlipNoticeHost />
          </GestureHandlerRootView>
        </ErrorBoundary>
     </Provider>
   );
 }
}
